import { Miniature } from '../../../models/miniature';

export const SpotMiniature: Miniature = {
    group: '',
    highlights: ['Tag with spot values'],
    icon: 'fa-map-pin',
    sortingOrder: 30,
    title: 'Spot',
    type: 'Spot'
};